<script lang="ts">
	export let maxCols: number = 5;
</script>

<div
	class={`w-fit h-fit grid grid-cols-2 sm:grid-cols-3
	${maxCols > 3 ? 'md:grid-cols-4' : ''}
	${maxCols > 4 ? 'lg:grid-cols-5' : ''}
	grid-flow-row gap-[2px] rounded overflow-hidden`}
>
	<div class="w-44 aspect-w-20 aspect-h-1"></div>
</div>
